// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { Messages } from './type';

const messages: Messages = {
  // A. Header & Footer
  Language: 'English',
  A001: 'My Home',
  A002: 'Courses',
  A003: 'Labs',
  A004: 'Log In',
  A005: 'Copyright {year} © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.',
  A006: 'Support Email : ',
  A007: 'Terms',
  A008: 'Privacy',
  A009: 'FAQ',
  A010: 'Support',
  A011: 'Challenges',
  A012: 'Exams',

  // B. HomePage
  B001: 'Hello, {username} !',
  B002: 'Collection',
  B003: 'Course History',
  B004: 'Workshop',
  B005: 'Course',
  B006: 'Lab',
  B007: '{timeString} left',
  B008: 'Duration : {totalDuration}',
  B009: 'Duration : ',
  B010: 'Video : {vodCount}',
  B011: 'Lab : {labCount}',
  B012: 'Assignment : {assignCount}',
  B013: 'Level : ',
  B014: 'Language : {lang}',
  B015: 'Start time : {timeString}',
  B016: 'End time : {timeString}',
  B021: 'Type',
  B022: 'Title',
  B023: 'Platform',
  B024: 'Level',
  B025: 'Status',
  B026: 'Complete{br}Time',
  B027: 'You currently don\'t have any courses or workshops now.',
  B028: 'Let\'s Explore',
  B029: 'You currently don\'t have any courses or workshops now.{br}Let\'s go get your first course soon !',
  B030: 'Go to my Collection',
  B031: 'Something went wrong, Please click {here} to reload page.{br}If it still cannot be accessed, please try again later.',
  'B031-1': 'here',
  B032: 'Go to My Home',
  B033: 'Completed',
  B034: 'Closed',
  B035: 'Incompleted',
  B036: 'Challenge',
  B037: 'Challenge : {challengeCount}', //For future
  B038: 'Link',
  B039: 'Go',
  B040: 'Exam',
  B041: 'Duration : ',
  B042: 'Multi Select : {examMultiSelect}',
  B043: 'Q&A :{examQna}',
  B044: 'Number of Exam :{examCount}',
  B045: 'HandsOn History',
  B046: 'Passed',
  B047: 'Failed',
  B048: 'Reviewing',
  B049: 'Stopped',
  B050: 'View',
  B051: 'You currently don\'t have any {handsOnType} now.{br}Let\'s go get your first {handsOnType} soon !',
  B052: 'Go to {handsOnType} list',
  B053: 'Review History',
  B054: 'Reviewed',
  B055: 'No Review',
  B056: 'Reviewee',
  B057: 'Review Time',
  B058: 'Name - level',
  B059: 'Go to Bifrost',
  B060: `
    Dear ECVer,{br}
    elearning already supports Microsoft AD for SSO login,{br}
    It is recommended that you go to Bifrost (SSO portal) to login for the first time immediately,{br}
    We will automatically bind your account with AD,{br}
    and close the original login methods (email, password).{br}
    {pdfLink}
  `,
  B061: 'No more reminder for this login',
  B062: 'Go to Bifrost',
  B063: 'ILT Course',
  B064: 'Location : {location}',

  // C. Course List & Lab List
  C001: 'Let\'s find your wanted courses !',
  C002: 'Let\'s find your wanted Lab!',
  C003: 'Domain',
  C004: 'Level',
  C005: 'No Result Found',
  C006: 'Courses',
  C007: 'Labs',
  C008: 'All',
  C009: 'Let\'s find your wanted Challenge!',
  C010: 'Challenges',
  C011: 'Let\'s find your wanted Training Test!',
  C012: 'Training Test',

  // D. Workshop Page & CoursePage
  D001: 'Opening hours',
  D002: 'Let\'s Get Started',
  D003: 'Coming soon',
  D004: 'Continue',
  D005: 'Let\'s Review',
  D006: 'Closed',
  D011: 'Duration: ',
  D012: 'Video: {count}',
  D013: 'Lab: {count}',
  D014: 'Assignment: {count}',
  D015: 'Video',
  D016: 'Lab',
  D017: 'Assignment',
  D018: 'Completed',
  D019: 'Workshop time is over.{br}Click leave button go back to My Home',
  D020: 'Leave',
  D021: 'Workshop time is over',
  D022: 'Workshop time is over.{br}Click leave button go back to My Home',
  D023: 'Leave',
  D024: 'Not Available',
  D025: 'Challenge: {count}',
  D026: 'Challenge',
  D027: 'Exam',
  D028: 'Exam: {count}',
  D029: 'Download results',
  D030: 'Download Success{br}If download isn\'t start, please cilck ',
  D031: 'here',
  D032: 'Download Failed{br}Please try again later',
  D033: 'Please choose a member to download result.',
  D034: 'Confirm',
  D035: 'Download Failed{br}This member has no result yet.',
  D036: 'Select All',
  D037: 'Only「challenge & exam」have result',
  D038: 'No member in this Workshop',
  D039: 'Please choose the download type：',
  D040: 'Total complete rate',
  D041: 'Individual result of members',
  D042: 'Please choose the data to download',
  D043: 'Complete rate',
  D044: 'Complete rate and exam logs',
  D045: 'Check In',
  D046: 'Check Out',
  D047: 'Time until check in',
  D048: 'Remain check in time',
  D049: 'Time until check out',
  D050: 'Remain check out time',
  D051: 'View Check In History',
  D052: 'Check in time:{br}{time}',
  D053: 'Check out time:{br}{time}',
  D054: 'hands-on is open to: {timeString}',
  D055: 'hands-on are Lab、Challenge、Exam',

  // E. Lab Page / Challenge Page
  E001: 'Start Lab',
  E002: 'Start Lab',
  E003: '{credit, plural, =0 {It will cost 0 credit.} =1 {It will cost # credit.} other {It will cost # credits.}}',
  E004: 'Let\'s Start',
  E005: '{creditEl} {credit, plural, =0 {credit} =1 {credit} other {credits}}',
  E006: 'You have {creditEl} {credit, plural, =0 {credit} =1 {credit} other {credits}}.',
  E007: 'You have only {creditEl} {credit, plural, =0 {credit} =1 {credit} other {credits}}.',
  E008: 'Please contact your Administrator if you want to start this lab.{br}{managerEmail}',
  E009: 'You can only use one lab or one challenge at the same time.{br}{br}Please finish the ongoing lab/challenge and then come back here to start the lab/challenge.',
  E010: 'Go to Ongoing Lab',
  E011: 'You have {count, plural, =one {# time} other {# times}}  to start this Lab.',
  E012: 'Go to Console',
  'E012-2': 'Go to Portal',
  E013: 'Sticky Notes',
  E014: 'You can make temporary notes in this Sticky Notes.\n\nAnything is written in this Sticky Notes, it will be removed when Lab is over or ended.',
  E015: 'The lab is currently unavailable, please choose other lab.',
  E016: 'Back to Labs list',
  E017: 'Account environment is Ready',
  E018: 'Go to Lab',
  E019: 'Deploying Lab',
  // E020: 'OK',
  E021: 'Deployment is error, please try it again.',
  // E022: 'Try Again',
  E023: 'Time is over',
  E024: 'Hope this lab give you a deeper understanding of the cloud world, keep exploring more!',
  E025: 'Leave',
  E026: 'Credit is a resource that you have and can be used to start the lab.',
  E027: 'Overview',
  E028: 'I\'m done !',
  E029: 'Workshop',
  E030: 'Hint on',
  E031: 'Hint off',
  E032: 'Leaderboard',
  E033: 'Rank',
  E034: 'Name',
  E035: 'Complete Time',
  E036: 'Hint Open',
  E037: 'Your ranking is',
  E038: 'The challenge is currently unavailable, please choose other challenge.',
  E039: 'Start Challenge',
  E040: 'Start Challenge',
  E041: 'Go to Ongoing Challenge',
  E042: 'You have passed this task, {br}click the button to continue next task.',
  E043: 'End the challenge and check out the rank.',
  E044: 'Enter your Token to {br}check the task answer.',
  E045: 'Click the button to confirm the answer.',
  E046: 'Put your token here',
  E047: 'Next task',
  E048: 'I\'m done !',
  E049: 'Go !',
  E050: '*Token is incorrect',
  E051: '*Task isn\'t completed',
  E052: 'Credit is a resource that you have and can be used to start the challenge.',
  E053: 'Time is over',
  E054: 'Click the button to back to the main page. {br}To use the challenge again, please re-enter from the main page.',
  E055: 'Using hints will affect rankings, please use them with caution.',
  E056: '．Without using hints, you will be ranked in "Hint off"{br}．Using any one of hints, you will be ranked in "Hint on"',
  E057: 'Hint',
  E058: 'Unlock',
  E059: 'Quit',
  E060: 'Reset',
  E061: 'Resetting the environment can restore the initial settings, but up to 2 times.',
  E062: 'Are you sure to reset the environment?{br}Resetting the environment clears the record of previous actions.',
  E063: 'Are you sure to give up the challenge?{br}This record will not be saved.',
  E064: 'Confirm',
  E065: 'Cancel',
  E066: 'Click to go to check answer.',
  E067: 'Start Task',
  E068: 'Let\'s Start',
  E069: 'Deploying Challenge',
  E070: 'You must complete "all tasks" to be ranked on the leaderboard(daily update).',
  E071: 'No rank record yet',
  E072: 'Challenge still prewarming, please try again later',
  E073: 'Network busy, please try again later',
  E074: 'Deploying',
  E075: 'Deployment succeeded！',
  E076: 'Deployment failed',
  E077: 'To obtain the course please contact: ',

  // F. CourseContentPage ( VoD )
  F001: 'Course list',
  F002: 'Note',
  F003: 'Do you want to continue video playback?',
  F004: 'OK',
  F005: 'Cancel',
  F006: 'Video is playing in picture in picture.',
  F007: 'Back to Main Screen',
  F008: 'Add a new note !',
  F009: 'Save',
  F010: 'The note has been deleted.',
  F011: 'Recover',
  F012: 'You haven\'t added any notes yet.\nTry to add some notes in this module',
  F013: 'Hands-on lab.{br}Let\'s go to lab and get started!',
  F014: 'Go to lab',
  F015: 'Continue',
  F016: 'Congratulations! You\'ve successfully completed this course. {br} Keeping explore more Cloud World.',
  F017: 'Back to My Home',
  F018: 'Almost done!{br}Let\'s go back to finish uncompleted module.',
  F019: 'Continue',
  F020: 'We have provided some additional resource link for you, try to click the button below to check it out!',
  F021: 'Open Link',
  F022: 'This course is currently unavailable.{br}Please contact to Your Administrator if you want to enroll this course. {managerEmail}',
  F023: 'Back to My Home',
  F024: 'Lab: ',
  F025: 'No subtitles',
  F026: 'Let\'s find how deep your understanding of the topic is!',
  F027: 'Skip',
  F028: 'Start',
  F029: 'Question {currentQuestion} of {totalQuestions}',
  F030: 'Check Answer',
  F031: 'Correct',
  F032: 'Next',
  F033: 'Wrong',
  F034: 'Check Result',
  F035: 'Result',
  F036: 'You got {correctQuestions}/{totalQuestions} correct',
  F037: 'Score',
  F038: 'Retry',
  F039: 'Continue',
  F040: 'Go to challenge',
  F041: 'Challenge: ',
  F042: 'Go to exam',
  F043: 'Exam: ',
  // G. MemberCenter
  'credit': '{credit, plural, =0 {0 credit} =1 {# credit} other {# credits}}',
  G001: 'Username',
  G002: 'Male',
  G003: 'Female',
  G004: 'Birthday',
  G005: 'Organization',
  G006: 'Role',
  G007: 'Change Password',
  G008: 'Interests',
  G009: 'Choose your interests to get the best recommendation.',
  G010: 'Profile',
  G011: 'Management Page',
  G012: 'Log out',
  G013: 'Change Password',
  G014: 'After change, please log in to the system again with the new password.',
  G015: 'Please enter current password',
  G016: 'Please enter new password',
  G017: 'Password must be 8 characters long or more and include at least one number',
  G018: 'Change',
  G019: 'The current password is incorrect',
  G020: 'The new password must be 8 characters long or more and include at least one number',
  G021: 'Your new password cannot be same as your current password',
  G022: 'your password has been changed successfully',
  G023: 'Please log in with the new password.',
  G024: 'OK',
  G025: 'Password change failed',
  G026: 'Something went wrong, Please try it again.',
  G027: 'Back',
  G028: 'Gender',
  G029: 'Others',
  G030: 'Current Password',
  G031: 'New Password',

  // H. Notification
  H001: 'Notification',
  H002: '{total, plural, =0 {0 credit} one {You got # new course!} other {You got # new courses!}}',
  H003: 'Go to Collection',
  H004: '{total, plural, =0 {0 credit} one {You got # new workshop!} other {You got # new workshops!}}',
  H006: `Hi { name }, welcome to {organizationName},
  let's explore Cloud World together!`,
  H008: 'You\'ve received message, let\'s take a look.',
  H009: 'Reply',
  H012: 'Your role has been changed to {roleName}',
  H013: 'You  currenly don\'t have any notifications.',
  H014: 'Loading',
  H015: 'Hi, The Exam({examName}) result is out!{br}Please go to "HandsOn History" to view the results.',
  H016: 'The reviewee({reviewee}) have completed Exam({examName}), {br}Please go to review.',
  H017: 'Go to review',
  // I. Support (Problem)
  I001: 'Hi, welcome to the support center,{br}Tell us about your problem and help you solve it !',
  I002: 'Support',
  I003: 'Please enter the subject',
  I004: 'Please select the type',
  I005: 'Content',
  I006: 'Platform Issue',
  I007: 'Feedback',
  I010: 'Others',
  I011: 'Please describe the problem here, so that we can help you quickly!',
  I012: 'Send',
  I013: 'Support History',
  I014: 'Upload pictures',
  I015: 'Successed!',
  I016: 'Your question has been sent successfully, please wait for reply. Thank you for your input!',
  I017: 'OK',
  I018: 'Send failed',
  I019: 'Something went wrong, Please click {retry} to reload page.{br}If it still cannot be accessed, please go to homepage and try again later.',
  'I019-1': 'here',
  I020: 'Back to My Home',
  I021: 'New message',
  I022: 'Send',
  I023: 'Delete',
  I024: 'solved',
  I025: 'If problem has been solved, please click solved button.',
  I026: ' ago',
  I027: 'Please enter feedback for this hands-on practice',
  I028: 'Rating: ',
  I029: 'Hands-On practice Satisfaction Survey',
  I030: 'Congratulations on complete the hands-on practice, invite you to rate this hands-on practice, and provide your valuable opinions as the basis for us to improve and enhance the quality, thank you!',
  I031: 'Drag and drop pictures to upload',
  I032: 'Maximum 5 picture',
  I033: 'When rating is less than 4 star, your opinion is required',

  // J. Login & SignUp
  J001: 'Login',
  J002: 'Log in with your eCloudture account',
  J003: 'Email',
  J004: 'Password',
  J005: 'Forget password',
  J006: 'Have no account?',
  'J006-1': 'Create one',
  J007: 'Log in',
  J008: 'Please enter your email',
  J009: 'Please enter valid email address',
  J010: 'Please enter your password',
  J011: 'Email or password is wrong, please check and try again.',
  J012: 'Sign up',
  J013: 'Create new eCloudture account',
  J014: 'Username',
  J015: 'Email',
  J016: 'Password',
  J017: 'Password must be 8 characters long or more & include at least one number',
  J018: 'Login',
  J019: 'Sign Up',
  J020: 'By clicking Sign Up, you agree to our {privacy} and {terms} of service.',
  'J020-1': 'privacy',
  'J020-2': 'terms',
  J021: 'Please enter your username',
  J022: 'Please enter your valid email',
  J023: 'Please enter your password',
  J024: 'Must be 30 characters or less',
  J026: 'Please enter valid email address',
  J027: 'This email has been used',
  J028: 'Password must be 8 characters long or more & include at least one number',
  J029: 'Create Failed',
  J030: 'Something went wrong. Please try again.',
  J031: 'Retry',
  J032: 'Confirm account',
  J033: 'We have sent a confirmation email to {br}{registeredEmail}{br} Please check your mailbox and click the link to complete the account activation!',
  J034: 'Back to Login',
  J035: 'Resend',
  J036: 'Email have been sent! Wait in 30 seconds to resend the email again.',
  J037: 'Welcome !',
  J038: 'This account has been confirmed ! Your account is',
  'J038-2': 'Please log in to start explore and learn on eCloudture.',
  'J038-3': 'Thanks for joining and enjoy all courses on eCloudture.',
  J039: 'Login',
  J040: 'Back to Login',
  J041: 'Forget password',
  J042: 'Please enter your registed email, we will send you a email to reset password.',
  J043: 'Email',
  J044: 'Send',
  J045: 'please enter valid email address',
  J046: 'Email has been sent.',
  J047: 'An email has been sent , please check your mailbox and click on the link to reset password.',
  J048: 'Back to Login',
  J049: 'Resend',
  J050: 'Resend in 30 seconds',
  J051: 'Reset Password',
  J052: 'Enter the new password.',
  J053: 'Password',
  J054: 'Password must be 8 characters long or more & include at least one number',
  J055: 'Reset',
  J056: 'Password must be 8 characters long or more & include at least one number',
  J057: 'Password Reset Failed',
  J058: 'Something went wrong, Please try it again.',
  J059: 'Back',
  J060: 'Password Reset Successful',
  J061: 'Please log in with the new password.',
  J062: 'Go to Login Page',
  J063: 'This account has not been verified, please go check your mailbox and complete account activation',
  J064: 'There is a problem with the authentication. {br} Please return to Bifrost for re-verification',
  'J064-1': 'here',
  J065: 'ECVers need to log in via Bifrost',
  J066: 'Verifying login information...',
  J067: 'ECVers do not need to register, please log in via the Bifrost.',
  J068: 'eCloudvalley colleagues can login through Bifrost without reset password.',
  J069: 'Still reset password',

  // K: Exam Page & Exam Review
  K001: 'Start Exam',
  K002: 'Exam Record',
  K003: 'Submit',
  K004: 'Credit is a resource that you have and can be used to start the exam.',
  K005: 'The exam is currently unavailable, please choose other exam.',
  K006: 'Back to Top',
  K007: 'Limited time',
  K008: 'Number of participants',
  K009: 'Level',
  K010: 'Multi Select',
  K011: 'min',
  K012: 'Do you want to submit ?',
  K013: 'Your questions are empty !',
  K014: 'Please finish the ongoing exam and then come back here to start this exam.',
  K015: 'Start Exam',
  K016: 'Go to Ongoing Exam',
  K017: 'Passing Score',
  K018: 'Q&A',
  K019: 'Upload File',
  K020: 'Reviewee：',
  K021: 'Exam Name：',
  K022: 'Mulit Select points：',
  K023: 'Correct Number：',
  K024: 'Wrong Number：',
  K025: 'Mulit Select',
  K026: 'Q & A',
  K027: 'Total points',
  K028: 'Total questions',
  K029: 'Each question',
  K030: 'points',
  K031: 'Answer:',
  K032: 'Score:',
  K033: 'Comment:',
  K034: 'Do you want to submit the score?',
  K035: 'You have already submit this exam review.',
  K036: 'There is an error in your URL, unable to find the correct exam review.',
  K037: 'Can not over {limitScore} points.',
  K038: 'Total file size is over 6MB. Please zip the file',
  K039: 'Status：',
  K040: 'Q&A total score：',
  K041: 'The score you gave：',
  K042: 'Cannot enter more than 5000 characters',
  K043: 'File size can\'t exceed 6MB',

  // Landing Page
  M002: 'The cloud expert closest to you',
  M003: 'Try Now',
  M005: 'Hands-on lab experience brings you into your own experimental situation. A detailed manual guides you step by step through the experiment. There is no credit card required to use the lab, you can easily start using it with credits, and you can effectively control the amount you use without worrying about overuse and cost overruns.After a complete learning journey and hands-on work, you will have a better understanding of the course and master the key concepts.',
  M006: 'Multi-Cloud Learning',
  M007: 'We provide most Completed and Advanced multi-cloud application courses, such as Amazon Web Service, Azure, etc. You can find the best learning journey through different cloud platforms, and learn step by step with labs and videos.',
  M008: '7-Domains in 1-Platform',
  M009: 'You can choose courses according to your interests  from these seven domains. We also provide learning paths for different roles so that you can easily start your learning journey.',
  M017: 'Glocalization Learning',
  M018: 'eCloudture service base covers Taiwan and ASEAN countries, providing bilingual education in both Chinese and English. In the future, we will continue to provide more languages ​​to achieve the goal of learning without borders. Let more people know and learn about the cloud through the eCloudture elearning platform.',
  M024: 'Start your cloud journey now!',
  M025: 'Sign up',
  M026: 'Support Email',
  M027: 'Terms',
  M028: 'Privacy',
  M029: 'FAQ',
  //General
  Z001: '{day} {day, plural, =0 {day} =1 {day} other {days}} {hour} {hour, plural, =0 {hour} =1 {hour} other {hours}} left',
  'Z001-1': '{hour} {hour, plural, =0 {hour} =1 {hour} other {hours}} {minute} {minute, plural, =0 {minute} =1 {minute} other {minutes}} left',
  'Z001-2': '{minute} {minute, plural, =0 {minute} =1 {minute} other {minutes}} {second} {second, plural, =0 {second} =1 {second} other {seconds}} left',
  Z002: 'Introduction',
  Z003: 'Basic',
  Z004: 'Advanced',
  Z005: 'Specialist',
}

export { messages as default }
